import React from 'lib/react';
import PropTypes from 'prop-types';
import FilesWidget from 'features/orderHistory/components/details-button/FilesWidget.component';
import EmailFilesWidget from 'features/orderHistory/components/details-button/EmailFilesWidget.component';

function FilesDropdownContent({
  reportId, showEmailOptions, selectedFiles, emailFiles, setSelectedFiles,
  setShowEmailOptions, handleShowEmailOptionsChange, handleClickAway, primaryProductID,
  showFilesEsxUpgrade,
}) {
  if (showEmailOptions) {
    return (
      <EmailFilesWidget
        reportId={reportId}
        selectedFiles={emailFiles}
        setShowEmailOptions={setShowEmailOptions}
        handleCancel={handleClickAway}
      />
    );
  }

  return (
    <FilesWidget
      reportId={reportId}
      selectedFiles={selectedFiles}
      setSelectedFiles={setSelectedFiles}
      handleShowEmailOptionsChange={handleShowEmailOptionsChange}
      primaryProductID={primaryProductID}
      showFilesEsxUpgrade={showFilesEsxUpgrade}
    />
  );
}
FilesDropdownContent.defaultProps = {
  handleClickAway: null,
  showFilesEsxUpgrade: false,
};
FilesDropdownContent.propTypes = {
  reportId: PropTypes.number.isRequired,
  showEmailOptions: PropTypes.bool.isRequired,
  selectedFiles: PropTypes.shape({
    fileTypeName: PropTypes.string,
    fileFormatID: PropTypes.number,
    reportFileDescription: PropTypes.string,
  }).isRequired,
  emailFiles: PropTypes.objectOf(
    PropTypes.shape({
      fileTypeName: PropTypes.string.isRequired,
      fileFormatID: PropTypes.number.isRequired,
    }),
  ).isRequired,
  setShowEmailOptions: PropTypes.func.isRequired,
  setSelectedFiles: PropTypes.func.isRequired,
  handleShowEmailOptionsChange: PropTypes.func.isRequired,
  handleClickAway: PropTypes.func,
  primaryProductID: PropTypes.number.isRequired,
  showFilesEsxUpgrade: PropTypes.bool,
};

export default FilesDropdownContent;
